import type { ContentTableConfig } from "@gplibraries/react/components";
import { StringFormatter } from "@gplibraries/utils";

export const bargainWarehousePartsTableConfig: ContentTableConfig = {
  columns: {
    part: {
      data_type: 'link',
      label: 'Part',
      headingStyles: {
        desktop: {
          width: '440px'
        },
        mobile: {
          width: 'auto',
        }
      }
    },
    part_number: {
      label: 'Part #',
      headingStyles: {
        desktop: {
          width: '120px'
        },
        mobile: {
          width: '80px',
        }
      }
    },
    quantity: {
      label: 'Quantity',
      headingStyles: {
        desktop: {
          width: '80px'
        },
        mobile: {
          width: '70px',
        }
      }
    },
    list_price: {
      label: 'List Price',
      headingStyles: {
        desktop: {
          width: '100px'
        },
        mobile: {
          width: '80px',
        }
      },
      render: (row) => row.list_price ? StringFormatter.currency(row.list_price) : null,
    },
    where_used: {
      label: 'Where Used',
      headingStyles: {
        mobile: {
          width: '240px'
        }
      }
    },
  }
}